import { initGTM, sendToGTM } from '@actions/gtm';
import React, { createContext, useContext, useEffect, useReducer } from 'react';

export const initialState = {
  dataLayer: undefined,
  dataLayerName: 'dataLayer',
  environment: undefined,
  nonce: undefined,
  id: '',
  injectScript: true,
};

export const GTMContext = createContext(initialState);
export const GTMContextDispatch = createContext(undefined);

const dataReducer = (state, data) => {
  sendToGTM({ data, dataLayerName: state?.dataLayerName });
  return state;
};

const useGTMDispatch = () => {
  const context = useContext(GTMContextDispatch);
  if (context === undefined) {
    throw new Error('dispatchGTMEvent must be used within a GTMProvider');
  }

  return context;
};

/**
 * The Google Tag Manager Provider
 */
const GTMProvider = ({ state, children }) => {
  const [store, dispatch] = useReducer(dataReducer, {
    ...initialState,
    ...state,
  });

  useEffect(() => {
    if (!state || state.injectScript === false) return;
    const mergedState = { ...store, ...state };

    initGTM(mergedState);
  }, [state, store]);

  return (
    <GTMContext.Provider value={store}>
      <GTMContextDispatch.Provider value={dispatch}>
        {children}
      </GTMContextDispatch.Provider>
    </GTMContext.Provider>
  );
};

export { GTMProvider, useGTMDispatch, sendToGTM };
